import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useGetLiveStatusQuery } from '../../apps/professional-app/fa/store/fa'
import { selectHasLiveMeetings, selectLiveMeetingsPollingEnabled, setHasLiveMeeting } from '../../store/liveMeetings/liveMeetings'
import { AlertIcon } from '../AlertIcon/AlertIcon'

export const LiveIcon: React.FC = () => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const hasLiveSession = useAppSelector(selectHasLiveMeetings)
  const roomSessionsPollingEnabled = useAppSelector(selectLiveMeetingsPollingEnabled)

  const { data: liveStatus } = useGetLiveStatusQuery(
    { accountId },
    { refetchOnMountOrArgChange: true, pollingInterval: 30000, skipPollingIfUnfocused: true, skip: roomSessionsPollingEnabled },
  )

  useEffect(() => {
    if (!liveStatus?.data) {
      return
    }
    dispatch(setHasLiveMeeting(liveStatus.data.hasLiveSession))
  }, [dispatch, liveStatus])

  return (
    <AlertIcon size={1.8} active={hasLiveSession}>
      <i className='bi bi-broadcast' />
    </AlertIcon>
  )
}
